import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-sector-saver',
  templateUrl: './sector-saver.page.html',
  styleUrls: ['./sector-saver.page.scss'],
})
export class SectorSaverPage implements OnInit {
  @Input() original:any;
  @Input() data:any;

  changed:any[]=[];
  _computeChanged(){
    if(!this.original) return [];
    if(!this.data) return [];
    const {original,data}= this;
    const changes = [];
    const frMap = {
      'name':'nom',
      'created':'creation',
      'status':'statut'
    };
    Object.keys(frMap).forEach( (flatKey:string)=>{
      let text = frMap[flatKey];
      if(data[flatKey] != original[flatKey]){
        let value = data[flatKey];
        let old = original[flatKey];
        if(value && flatKey == 'created'){
          value = value.toISOString().replace(/T.+/,'');
          if(old){
            old = old.toISOString().replace(/T.+/,'');
          }
          if(value == old) return;
        }
        if(!old){
          old = '      ';
        }
        changes.push({text:text,attr: flatKey, old:old, new:value});
      }
    });
    let removedTeams = original.teams.filter( (ot:string)=>{
      return !data.teams.includes(ot);
    });
    let addedTeams = data.teams.filter( (ot:string)=>{
      return !original.teams.includes(ot);
    });
    let removedRoads = original.roads.filter( (ot:string)=>{
      return !data.roads.includes(ot);
    });
    let addedRoads = data.roads.filter( (ot:string)=>{
      return !original.roads.includes(ot);
    });
    if(removedTeams.length || addedTeams.length){
      changes.push({text:"equipes", attr: 'teams', old: original.teams.join(', '), new: data.teams.join(', ')})
    }
    if(removedRoads.length || addedRoads.length){
      changes.push({text:"chemins", attr: 'roads', old: original.roads.join(', '), new: data.roads.join(', ')})
    }
    let allPossibleRoadNumbers =[...original.roads];

    data.roads.forEach( ( r )=>{
      if(!allPossibleRoadNumbers.includes(r)){
        allPossibleRoadNumbers.push(r);
      }
    });
    let roadInfoChanges = false;
    allPossibleRoadNumbers.forEach( (n )=>{
        if(!original.roadInfo[n] && data.roadInfo[n]){
          // one has been added
          roadInfoChanges = true;
        }
        if(original.roadInfo[n] && !data.roadInfo[n]){
          // one has been deleted
          !original.roadInfo[n] && data.roadInfo[n]
        }
          if(!original.roadInfo[n] || (original.roadInfo[n].season != data.roadInfo[n].season)){
            roadInfoChanges = true;
            console.log(n,'seasong chanfged')
          }
          if(!original.roadInfo[n] || original.roadInfo[n].year != data.roadInfo[n].year){
            roadInfoChanges = true;
          }
    })
    console.log('roadInfoChanges?',roadInfoChanges,original.roadInfo,data.roadInfo)
    if(roadInfoChanges){
            changes.push({text:"détails chemins", attr: 'roads', old: Object.keys( original.roadInfo).map( (key)=>{
              let ifo = original.roadInfo[key];
              return `${ifo.number||'-'}${ifo.season||'-'}${ifo.year||'-'}`;
            }).join(','), new: Object.keys( data.roadInfo).map( (key)=>{
              let ifo = data.roadInfo[key];
              return `${ifo.number||'-'}${ifo.season||'-'}${ifo.year||'-'}`;
            }).join(',')})
            console.log('chagnes puished',changes)
    }
    return this.changed=changes;
  }
  constructor(public modalController: ModalController) { }


  ngOnInit() {
    console.log('sectorSaver',{original: this.original,data:this.data})
    console.log(this.changed);
    this._computeChanged();
  }

  save(){



    this.modalController.dismiss({
      confirmed:true
    });
  }
  cancel() {
    this.modalController.dismiss({
      confirmed:false
    });
   }
}
